module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo2024_tokyo-f5ac23746fe9e15e7048b20ed182b8aa.svg";